import { Navigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import AuthContext from "../context/AuthContext";
import LoadingScreen from "../Components/LoadingScreen/LoadingScreen";
import { refreshToken } from "../api/authApi";

const PrivateRoute = ({ children }) => {
    const { state, dispatch } = useContext(AuthContext);
    
    useEffect(() => {
        const validateSession = async () => {
            if (!state.isAuthenticated && state.token) {
                dispatch({ type: 'SET_LOADING', payload: true });
                const response = await refreshToken();
                
                if (response.status === 'success') {
                    dispatch({
                        type: 'LOGIN',
                        payload: {
                            user: response.data.user,
                            token: response.data.token
                        }
                    });
                } else {
                    dispatch({ type: 'LOGOUT' });
                }
                dispatch({ type: 'SET_LOADING', payload: false });
            }
        };

        validateSession();
    }, [dispatch, state.isAuthenticated, state.token]);

    if (state.isLoading) {
        return <LoadingScreen />;
    }

    if (!state.isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default PrivateRoute;